import { AdBannerResponseItem, AdBannerItem } from '@/types/AdBanner'

export function convertAdBannerItem(data: AdBannerResponseItem): AdBannerItem {
  return {
    hospitalId: `${data.hospital_id}`,
    hospitalName: `${data.hospital_name}`,
    pcImageSrc: `${data.op_web_pc_img}`,
    spImageSrc: `${data.op_web_sp_img}`
  }
}
